import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Gates the Cart Assistant cold-start prompt-starters editor. Store-config view is required to
// reach the page; the modify permission is surfaced as an in-tool permission on the nav entry.
// The feature toggle keeps the tool hidden until the Roulette flag `rt_cart_assistant_prompt_starters`
// is created and ramped (follow-up), so the tool ships dark until the backend write path is ready.
export const cartAssistantEditorAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StoreConfigsView],
  featureToggles: [FeatureToggle.cartAssistantPromptStarters],
  restrictedBannersAllowed: true,
}
